import { render, staticRenderFns } from "./MobilePager.vue?vue&type=template&id=5f0e0614&scoped=true&"
import script from "./MobilePager.vue?vue&type=script&lang=ts&"
export * from "./MobilePager.vue?vue&type=script&lang=ts&"
import style0 from "./MobilePager.vue?vue&type=style&index=0&id=5f0e0614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0e0614",
  null
  
)

export default component.exports